import React from 'react'
import { SelectInput, TextInput } from 'react-admin'
import { activityStatusChoices } from 'services/cfg/form'
import KFileInput from 'ui-shared/WrappedInputs/KFileInput'
import SupplierSelectInput from 'ui-shared/CustomInputs/SupplierSelectInput'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import MainProductForm, {
  MainProductFormProps,
} from 'ui-shared/Forms/MainProductForm'
import HighlightsInput from 'ui-shared/WrappedInputs/HighlightsInput'
import LocationFeatureInput from 'ui-shared/CustomInputs/LocationFeatureInput'
import LocationFacetSection from 'ui-shared/Facets/FacetFormSections/LocationFacetSection'
import LocationArrangementsInput from './LocationArrangementsInput'
import BookingTimeLimitInput from 'ui-shared/WrappedInputs/BookingTimeLimitInput'
import UpsellingSelector from 'ui-shared/FormComponents/UpsellingSelector'
import TimePicker from 'ui-shared/WrappedInputs/TimePicker'
import KAccordion from 'ui-shared/accordions/KAccordion'
import LocationTimeSuggestionsInput from './LocationTimeSuggestionsInput'
import LocationByRulePricingInput from 'ui-shared/FormComponents/pricing/byRules/LocationByRulePricingInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import { yupResolver } from '@hookform/resolvers/yup'
import { locationVS } from 'services/validations/catalog/location'

type LocationFormProps = MainProductFormProps

const LocationForm: React.FC<LocationFormProps> = (props) => {
  return (
    <MainProductForm
      {...props}
      facetFields={<LocationFacetSection />}
      resolver={yupResolver(locationVS)}
    >
      <LocalizedInputText
        source="nickname"
        label="form.fields.locationNickname"
        fullWidth
      />

      <UpsellingSelector upsellingEntity="locationupselling" />
      <SupplierSelectInput source="supplier" />
      <SelectInput source="status" choices={activityStatusChoices} required />

      <TextInput
        source="fullAddress"
        label="form.fields.locationFullAdress"
        fullWidth
      />
      <KNumberInput source="peopleCapacity" label="People Capacity" />
      <KNumberInput source="roomCapacity" label="Room Capacity (m2)" />
      <BookingTimeLimitInput />
      <KFileInput source="planimetry" />

      {/* Arrangements section */}
      <KAccordion accordionTitle="Arrangements & Features">
        <LocationArrangementsInput />
        <LocationFeatureInput type="characteristic" source="characteristics" />
        <LocationFeatureInput type="equipment" source="equipments" />
      </KAccordion>

      <HighlightsInput />

      {/* Time slots section */}
      <LocationTimeSuggestionsInput />

      {/* Time slots & Pricing */}
      <KAccordion accordionTitle="Time slots & Pricing">
        <TimePicker source="availableFrom" label="Available From" />
        <TimePicker source="availableTo" label="Available to" />
        <LocationByRulePricingInput />
      </KAccordion>
    </MainProductForm>
  )
}

export default LocationForm
